import Vue from "vue";
import Vuex from "vuex";
import caseData from "./case";
import doCase from "./doCase";
import Api from "../api/api";
var http = new Api();
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        pattern: "",
        userInfor: {},
        // 通知列表
        noteList: []
    },
    getters: {
        userInfor: function (state) {
            return state.userInfor;
        },
        getNoteList: function (state) {
            return state.noteList;
        },
    },
    mutations: {
        setCasePattern: function (store, data) {
            store.pattern = data;
        },
        setUserInfo: function (state, data) {
            state.userInfor = data;
        },
        /** 存储通知列表 */
        setNoteList: function (state, data) {
            state.noteList = data;
        },
    },
    actions: {
        // 更新通知信息
        updataNotlist: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.intelligentNotification({
                    pageNo: 1,
                    pageSize: 99
                }).then(function (res) {
                    console.log(res.data);
                    if (res.data.success && res.data.data.list) {
                        commit("setNoteList", res.data.data.list);
                    }
                    else {
                        commit("setNoteList", []);
                    }
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        /**
       *  查询用户信息
       * @param id string
       */
        queryUserInfo: function (_a, code) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.userInfo({
                    code: code
                }).then(function (res) {
                    if (res.data.data) {
                        var info = {
                            headImagePath: res.data.data.headImagePath,
                            name: res.data.data.name,
                            code: res.data.data.code,
                            teacher: res.data.data.teacher,
                            student: res.data.data.student,
                            admin: res.data.data.admin
                        };
                        commit("setUserInfo", info);
                        resolve();
                    }
                    else {
                        reject("暂无数据");
                    }
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
    },
    modules: {
        case: caseData,
        doCase: doCase
    }
});
